/**
 * CSRF Token Management
 * Handles CSRF token storage and inclusion in requests
 */

const CSRF_COOKIE_NAME = 'csrf_token';
const CSRF_HEADER_NAME = 'X-CSRF-Token';

// In-memory fallback storage for CSRF token
let cachedCsrfToken = null;

/**
 * Get CSRF token from cookie
 */
export const getCsrfTokenFromCookie = () => {
  const name = CSRF_COOKIE_NAME + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
};

/**
 * Fetch CSRF token from server
 */
export const fetchCsrfToken = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/csrf-token`, {
      method: 'GET',
      credentials: 'include'
    });
    const data = await response.json();
    // Store in memory as fallback
    if (data.csrf_token) {
      cachedCsrfToken = data.csrf_token;
    }
    return data.csrf_token;
  } catch (error) {
    console.error('Failed to fetch CSRF token:', error);
    return null;
  }
};

/**
 * Get CSRF headers for requests
 */
export const getCsrfHeaders = () => {
  // Try cookie first, then fall back to cached token
  const token = getCsrfTokenFromCookie() || cachedCsrfToken;
  if (!token) {
    console.warn('CSRF token not available');
    return {};
  }
  return {
    [CSRF_HEADER_NAME]: token
  };
};

/**
 * Initialize CSRF token (call on app start)
 */
export const initializeCsrf = async () => {
  // Check if token already exists in cookie
  let token = getCsrfTokenFromCookie();
  
  // If not in cookie, fetch from server (this also caches it in memory)
  if (!token) {
    token = await fetchCsrfToken();
  } else {
    // Even if cookie exists, cache it in memory for reliability
    cachedCsrfToken = token;
  }
  
  return token;
};
